import React from 'react'
import { Modal } from '@vwfs-bronson/bronson-react'
import { BookingAdditionalProduct, ICustomerBooking } from '../../../models/customer-data.interface';
import { formatter, getFromToTimestampsPair, newestTimestamp } from '../../../utils/time-utils';
import CopyActionWrapper from '../copy-action-wrapper';
import { isBifrostAuthConfig } from '../../../utils/auth-utils';
import { createDataDogQuery } from '../../../utils/DatadogUtils';

interface MessageModalInterface {
  showModal: boolean;
  title?: string;
  booking: ICustomerBooking;
  handleOnModalClose: () => void;
}


export default function BookingDetailsModal({ booking, showModal, handleOnModalClose, title }: MessageModalInterface) {
  if (!booking) {
    return null;
  }

  const keys: string[] = [];

  function renderAdditionalProduct(product: BookingAdditionalProduct) {
    const prods: string[] = [];

    /*
    if (product.isSelected || product.isIncluded) {
      prods.push(product.description);
    }*/

    product.choices?.map(choice => {
      if ((choice.isSelected || choice.includedInPackage) && !keys.includes(choice.code)) {
        keys.push(choice.code);
        prods.push(choice.name);
      }
    })
    return prods.map(prod => <li key={prod} style={{ margin: '0px' }}>{prod}</li>);
  }

  const lastUpdatedAt = newestTimestamp([booking.updateDateTime, booking.updatedAt, booking.paymentCapturedAt])
  const { from: fromTimestamp, to: toTimestamp } = getFromToTimestampsPair()
  const dataDogUri = createDataDogQuery(booking.customerId, booking.id, undefined, fromTimestamp, toTimestamp);

  const renderMessage = () => {
    return (
      <div
        data-testid='DetailsModal-content'
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem'
        }}>

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '2rem'
        }}>
          <div>
            <h5 style={{
              color: 'black',
              fontSize: '18px',
              lineHeight: '1.3',
              margin: '0',
            }}>Last Update</h5>
            <span data-testid='test-modal-message'>
              {lastUpdatedAt ? formatter.format(new Date(lastUpdatedAt)) : '-'}
            </span>
          </div>
          <div>
            <h5 style={{
              color: 'black',
              fontSize: '18px',
              lineHeight: '1.3',
              margin: '0',
            }}>Payment Capture</h5>
            <span data-testid='test-modal-message'>
              {booking.paymentCapturedAt ? formatter.format(new Date(booking?.paymentCapturedAt)) : '-'}
            </span>
          </div>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '2rem'
        }}>
          <div>
            <h5 style={{
              color: 'black',
              fontSize: '18px',
              lineHeight: '1.3',
              margin: '0',
            }}>Payment Transaction ID</h5>
            <span data-testid='test-modal-message-paymentId'>
              <CopyActionWrapper>{booking?.paymentDetails?.paymentId ? booking?.paymentDetails?.paymentId : '-'}</CopyActionWrapper>
            </span>
          </div>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '2.5rem'
        }}>
          <div style={{ flex: 1 }}>
            <h5 style={{
              color: 'black',
              fontSize: '18px',
              lineHeight: '1.3',
              margin: '0',
            }}>Pick up Station</h5>
            <span data-testid='test-modal-message'>
              {booking.station && booking.station?.stationName + " (" + booking.station?.address + ")"}
            </span>
          </div>
          <div style={{ flex: 1 }}>
            <h5 style={{
              color: 'black',
              fontSize: '18px',
              lineHeight: '1.3',
              margin: '0',
            }}>Drop off Station</h5>
            <span data-testid='test-modal-message'>
              {booking.returnStation && booking.returnStation.stationName + " (" + booking.returnStation.address + ")"}
            </span>
          </div>

          <div style={{ flex: 1 }}>
            <h5 style={{
              color: 'black',
              fontSize: '18px',
              lineHeight: '1.3',
              margin: '0',
            }}>Car Category</h5>
            <>
              {
                booking.offer?.vehicleCategory?.model?.vehicleImages[0]?.url && <img src={booking?.offer && booking.offer.vehicleCategory.model.vehicleImages[0]?.url} height="50px;" />
              }
              <p>{booking.offer?.vehicleCategory?.name}</p>
            </>
          </div>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '2rem'
        }}>
          <div>
            <h5 style={{
              color: 'black',
              fontSize: '18px',
              lineHeight: '1.3',
              margin: '0',
            }}>Aditional Products</h5>
            <span data-testid='test-modal-message'>
              <ul style={{ width: '250px' }} data-testid={`additional-products-${booking.id}-popup`}>
                {booking.offer?.additionalProducts?.map(product => renderAdditionalProduct(product))}
              </ul>
            </span>
          </div>
        </div>

        {isBifrostAuthConfig() && booking.id &&
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '2rem'
          }}>
            <div>
              <a target="blank" href={dataDogUri}>
                <h5 style={{
                  color: 'black',
                  fontSize: '18px',
                  lineHeight: '1.3',
                  margin: '0',
                }}>See Datadog Logs</h5>
              </a>
            </div>
          </div>
        }
      </div>
    )
  }

  return <Modal
    shown={showModal}
    onClose={handleOnModalClose}
    onConfirm={handleOnModalClose}
    buttonConfirmLabel='Ok'
    buttonConfirmText='Ok'
    title={title ? title : `Action`}
    large={false}
    stretch={true}
    status='info'
    testId='booking-details-modal'>
    {renderMessage()}
  </Modal>
}
